import * as React from 'react';
import styled from '@emotion/styled';
import { FONT_SIZE } from '@ordermentum/ui-static';
import { Input, InputProps } from '.';

const TinyInputWrapper = styled('div')`
  /* change style of input type number to be like textfield on FF */
  -moz-appearance: textfield;

  input {
    font-size: ${FONT_SIZE.SMALL};
  }

  /* hide input number spinners for chrome */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const TinyInput = (props: InputProps) => (
  <TinyInputWrapper>
    <Input {...props} />
  </TinyInputWrapper>
);

export default TinyInput;
